export default "__VITE_ASSET___6QvOX5B__"